// header SP版ナビ
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.l-header');
  const hamburger = document.querySelector('.l-header__hamburger');
  const overlay = document.querySelector('.l-header__overlay');

  function toggleMenu() {
    const isOpen = header.classList.toggle('is-open');
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }

  hamburger.addEventListener('click', toggleMenu);
  overlay.addEventListener('click', toggleMenu);
});

// header PC版 会社情報ドロワー
document.addEventListener('DOMContentLoaded', function () {
  const companyItem = document.querySelector('.l-header__gnav-item--company');
  if (!companyItem) return;

  const drawer = companyItem.querySelector('.l-header__gnav-drawer');
  const OPEN_CLASS = 'is-company-open';
  const PC_BREAKPOINT = 768;
  let closeTimer = null;

  function isPc() {
    return window.innerWidth > PC_BREAKPOINT;
  }

  function openDrawer() {
    if (!isPc()) return;
    clearTimeout(closeTimer);
    companyItem.classList.add(OPEN_CLASS);
  }

  function scheduleClose() {
    if (!isPc()) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      companyItem.classList.remove(OPEN_CLASS);
    }, 200);
  }

  companyItem.addEventListener('mouseenter', openDrawer);
  companyItem.addEventListener('mouseleave', scheduleClose);

  if (drawer) {
    drawer.addEventListener('mouseenter', openDrawer);
    drawer.addEventListener('mouseleave', scheduleClose);
  }

  window.addEventListener('resize', function () {
    clearTimeout(closeTimer);
    if (!isPc()) {
      companyItem.classList.remove(OPEN_CLASS);
    }
  });
});

// header 追従時背景色
window.addEventListener('scroll', function () {
  const header = document.querySelector('.l-header');

  if (window.scrollY > 0) {
    header.classList.add('is-scrolled');
  } else {
    header.classList.remove('is-scrolled');
  }
});

// header 標識 PDFモーダル（SP時別タブ）
document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('.js-pdf-modal');
  const modal = document.getElementById('pdfModal');
  const iframe = modal.querySelector('iframe');
  const close = modal.querySelector('.c-pdf-modal__close');
  links.forEach(link => {
    link.addEventListener('click', (e) => {
      // SP判定
      if (window.innerWidth <= 768) {
        link.setAttribute('target', '_blank');
        return; // モーダル処理しない
      }
      // PCはモーダル
      e.preventDefault();
      const pdfUrl = link.getAttribute('href');
      iframe.src = pdfUrl;
      modal.classList.add('is-open');
    });
  });
  close.addEventListener('click', () => {
    modal.classList.remove('is-open');
    iframe.src = '';
  });
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.classList.remove('is-open');
      iframe.src = '';
    }
  });
});

// MV slickフェードスライダー
$('.p-top__mv-slider').slick({
  autoplay: true,
  autoplaySpeed: 3500, // 3〜4秒の中間
  speed: 1200,         // フェード時間（ここ重要）
  fade: true,
  cssEase: 'ease-in-out',
  arrows: false,
  dots: false,
  pauseOnHover: false,
  pauseOnFocus: false,
});

// 対応サービス SPスライダー
(function () {
  const SP_BREAKPOINT = 768;
  let resizeTimer = null;
  let heightRefreshTimer = null;

  function isSp() {
    return window.innerWidth <= SP_BREAKPOINT;
  }

  function isServiceSpPage() {
    return isSp() && !!document.querySelector('.p-service__slider');
  }

  function getServiceBlockIndex(hash) {
    if (!hash || hash.length <= 1) return 0;

    const id = hash.slice(1);
    const $blocks = $('.p-service__slider .p-service__block');
    let index = 0;

    $blocks.each(function (i) {
      if (this.id === id) {
        index = i;
        return false;
      }
    });

    return index;
  }

  function scrollToServiceBody() {
    const header = document.querySelector('.l-header');
    const headerHeight = header ? header.offsetHeight : 0;
    const body = document.querySelector('.p-service__body');

    if (!body) return;

    const top = body.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'auto',
    });
  }

  function refreshServiceSliderHeight($slider) {
    if (!$slider.hasClass('slick-initialized')) return;
    $slider.slick('setPosition');
  }

  function scheduleServiceSliderHeightRefresh($slider) {
    clearTimeout(heightRefreshTimer);
    heightRefreshTimer = setTimeout(function () {
      refreshServiceSliderHeight($slider);
    }, 100);
  }

  function bindServiceSliderMedia($slider) {
    $slider.find('img').off('load.serviceSlider').on('load.serviceSlider', function () {
      scheduleServiceSliderHeightRefresh($slider);
    });

    $slider.find('video').off('loadedmetadata.serviceSlider').on('loadedmetadata.serviceSlider', function () {
      scheduleServiceSliderHeightRefresh($slider);
    });
  }

  function goToServiceHash($slider, hash, animate) {
    const index = getServiceBlockIndex(hash);
    $slider.slick('slickGoTo', index, !animate);
    scheduleServiceSliderHeightRefresh($slider);
  }

  function getArrowHtml(direction) {
    const baseUrl = typeof themeUrl !== 'undefined' ? themeUrl : '';
    const fileName = direction === 'prev'
      ? 'service-slider-arrow-prev.svg'
      : 'service-slider-arrow-next.svg';
    const label = direction === 'prev' ? '前へ' : '次へ';
    return (
      '<button type="button" class="p-service__slider-btn p-service__slider-btn--' + direction + '" aria-label="' + label + '">' +
      '<img src="' + baseUrl + '/dist/images/service/' + fileName + '" alt="" width="40" height="40">' +
      '</button>'
    );
  }

  function bindServiceSliderNav($slider) {
    const $arrows = $('.p-service__slider-arrows');

    $arrows.off('click.serviceSliderNav');
    $arrows.on('click.serviceSliderNav', '.slick-prev', function (e) {
      e.preventDefault();
      if ($(this).hasClass('slick-disabled')) return;
      $slider.slick('slickPrev');
    });
    $arrows.on('click.serviceSliderNav', '.slick-next', function (e) {
      e.preventDefault();
      if ($(this).hasClass('slick-disabled')) return;
      $slider.slick('slickNext');
    });
  }

  function initServiceSlider() {
    const $slider = $('.p-service__slider');
    if (!$slider.length) return;

    const sp = isSp();
    const isInitialized = $slider.hasClass('slick-initialized');
    const hash = window.location.hash;
    const hasHash = hash.length > 1;

    if (sp && !isInitialized) {
      if (hasHash) {
        $slider.addClass('is-hash-loading');
      }

      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        adaptiveHeight: true,
        initialSlide: getServiceBlockIndex(hash),
        arrows: true,
        dots: true,
        prevArrow: getArrowHtml('prev'),
        nextArrow: getArrowHtml('next'),
        appendArrows: $('.p-service__slider-arrows'),
        appendDots: $('.p-service__slider-dots'),
      });

      bindServiceSliderNav($slider);
      bindServiceSliderMedia($slider);

      $slider.on('beforeChange.serviceSlider', function () {
        $slider.find('video').each(function () {
          this.pause();
        });
      });

      $slider.on('init.serviceSlider', function () {
        scheduleServiceSliderHeightRefresh($slider);

        if (hasHash) {
          requestAnimationFrame(function () {
            scrollToServiceBody();
            scheduleServiceSliderHeightRefresh($slider);
            $slider.removeClass('is-hash-loading');
          });
        }
      });

      $slider.on('afterChange.serviceSlider', function () {
        scheduleServiceSliderHeightRefresh($slider);
      });
    } else if (!sp && isInitialized) {
      $slider.off('.serviceSlider');
      $slider.find('img').off('load.serviceSlider');
      $slider.find('video').off('loadedmetadata.serviceSlider');
      $('.p-service__slider-arrows').off('click.serviceSliderNav');
      $slider.removeClass('is-hash-loading');
      $slider.slick('unslick');
    }
  }

  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initServiceSlider, 200);
  });

  $(initServiceSlider);

  window.greesessServiceSlider = {
    isServiceSpPage: isServiceSpPage,
    goToHash: function (hash) {
      const $slider = $('.p-service__slider');
      if (!$slider.length || !$slider.hasClass('slick-initialized')) return false;
      goToServiceHash($slider, hash, true);
      scrollToServiceBody();
      return true;
    },
  };
})();

// 資格・認定保有者 SP画像スライダー
(function () {
  const SP_BREAKPOINT = 768;
  let resizeTimer = null;

  function isSp() {
    return window.innerWidth <= SP_BREAKPOINT;
  }

  function initCertificationVisualSlider() {
    const $slider = $('.p-certification__visual');
    if (!$slider.length) return;

    const sp = isSp();
    const isInitialized = $slider.hasClass('slick-initialized');

    if (sp && !isInitialized) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 8000,
        cssEase: 'linear',
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        variableWidth: true,
        swipe: false,
        touchMove: false,
        draggable: false,
      });

      $slider.on('beforeChange.certificationVisual', function () {
        $slider.slick('slickSetOption', 'autoplaySpeed', 0, false);
      });
    } else if (!sp && isInitialized) {
      $slider.off('.certificationVisual');
      $slider.slick('unslick');
    }
  }

  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initCertificationVisualSlider, 200);
  });

  $(initCertificationVisualSlider);
})();

// ページトップへ戻るボタン
document.addEventListener('DOMContentLoaded', function () {
  const pagetop = document.querySelector('.js-pagetop');
  if (!pagetop) return;

  const SHOW_OFFSET = 400;

  function togglePagetop() {
    pagetop.classList.toggle('is-visible', window.scrollY > SHOW_OFFSET);
  }

  pagetop.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });

  window.addEventListener('scroll', togglePagetop, { passive: true });
  togglePagetop();
});

// コンタクトフォーム メールアドレス一致チェック
document.addEventListener('submit', function(e) {
  const email = document.querySelector('[name="your-email"]').value;
  const confirm = document.querySelector('[name="your-email-confirm"]').value;
  if (email !== confirm) {
    alert('メールアドレスが一致しません');
    e.preventDefault();
  }
});

// ページ内スムーススクロール
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.l-header');

  const getHeaderHeight = () => header ? header.offsetHeight : 0;

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const hash = anchor.getAttribute('href');
      if (hash.length <= 1) return;

      const target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();

      if (window.greesessServiceSlider && window.greesessServiceSlider.isServiceSpPage()) {
        window.greesessServiceSlider.goToHash(hash);
        history.pushState(null, null, hash);
        return;
      }

      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: targetPosition - getHeaderHeight(),
        behavior: 'smooth'
      });

      history.pushState(null, null, hash);
    });
  });
});

// ページ遷移時の位置調整
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.l-header');

  const getHeaderHeight = () => header ? header.offsetHeight : 0;

  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    if (!target) return;

    if (window.greesessServiceSlider && window.greesessServiceSlider.isServiceSpPage()) {
      return;
    }

    // 初期アンカー位置補正
    setTimeout(() => {
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: targetPosition - getHeaderHeight(),
        behavior: 'auto'
      });
    }, 100);
  }
});